import { RequestAsync } from "../Servicios/AjaxRequest"

export const LoginAsync = async (params) => {
    const result =  await RequestAsync("inicio/Login",params)
    return result
}